"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERTICAL_ALIGN_TYPES = exports.TEXT_ALIGN_TYPES = exports.STRING_MATCHER_METHODS = exports.STATEFUL_MESSAGE_TYPES = exports.POPPER_WIDTH_SIZING = exports.FORM_CONTROL_VALIDATION_STATES = exports.DEFAULT_DATE_PICKER_PLACEMENTS = exports.CSS_PREFIX = exports.ALLOWED_INFO_ICONS = void 0;
const CSS_PREFIX = exports.CSS_PREFIX = 'sapcnqr';
const FORM_CONTROL_VALIDATION_STATES = exports.FORM_CONTROL_VALIDATION_STATES = ['error', 'warning', 'success', 'info', 'ai'];
const STATEFUL_MESSAGE_TYPES = exports.STATEFUL_MESSAGE_TYPES = ['error', 'info', 'success', 'warning', 'custom', 'ai'];
const ALLOWED_INFO_ICONS = exports.ALLOWED_INFO_ICONS = ['ai'];
const STRING_MATCHER_METHODS = exports.STRING_MATCHER_METHODS = ['startsWith', 'includes'];
const TEXT_ALIGN_TYPES = exports.TEXT_ALIGN_TYPES = ['left', 'right', 'center'];
const VERTICAL_ALIGN_TYPES = exports.VERTICAL_ALIGN_TYPES = ['top', 'middle', 'bottom'];
const POPPER_WIDTH_SIZING = exports.POPPER_WIDTH_SIZING = ['none', 'matchTarget', 'minTarget', 'maxTarget'];
const DEFAULT_DATE_PICKER_PLACEMENTS = exports.DEFAULT_DATE_PICKER_PLACEMENTS = ['bottom-start', 'top-start', 'bottom-end', 'top-end'];